const diagnostics = {
  faultinfo: {
    historyError: {
      faultTime: "故障时间",
      starttime: "开始时间",
      endtime: "结束时间",
      faultname: "故障名称",
      gbfaultlevel: "国标故障级别",
      faultlevel: "故障级别",
      faulttype: "故障类型",
      faultcode: "故障码",
      ispopfault: "是否推送",
      cartype: "车型名称",
      batchcode: "批次",
      vcuspareparts: "VCU零部件号",
      mcupareparts: "MCU零部件号",
      level1: "一级",
      level2: "二级",
      level3: "三级",
      level4: "四级",
      gbfault: "国标故障",
      selfdefinedfault: "自定义故障",
      allfault: "全部故障",
      popfault: "弹屏故障",
      partname: "零部件",
      createtime: "创建时间",
      faultstarttime: "故障时间",
      message1: "请选择需要导出的车辆",
      searchlabelwidth: {
        width1: "65px",
        width2: "90px",
        width3: "90px",
        width4: "90px"
      },
      tablewidth: {
        vinno: "170",
        licenseplate: "150",
        cartypename: "100",
        batchcode: "95",
        vcuspareparts: "120",
        mcupareparts: "123",
        faultname: "95",
        faultcode: "90",
        faulttype: "90",
        faultlevel: "90",
        gbfaultlevel: "120",
        partname: "90",
        createtime: "140",
        starttime: "160"
      }
    }
  },
  faultcodemanage: {
    faultcode: {
      faultcode: "故障码",
      faultname: "故障名称",
      faultlevel: "故障级别",
      brand: "车辆品牌",
      ispopfault: "是否推送",
      all: "所有",
      yes: "是",
      no: "否",
      faulttype: "故障类型",
      gbfault: "国标故障",
      selfdefinedfault: "自定义故障",
      level1: "一级",
      level2: "二级",
      level3: "三级",
      level4: "四级",
      partname: "零部件",
      loginname: "创建人",
      createdon: "创建时间",
      maintaininfo: "维修提示",
      solutions: "解决方案",
      message1: "请选择需要编辑的项",
      message2: "请选中需要删除项",
      confirm: "确定",
      prompt: "提示",
      cancel: "取消",
      whethertodelete: "是否删除",
      deletesuccessfully: "成功删除",
      searchLabelWidth: "70px",
      tablewidth: {
        faulttype: "120",
        faultcode: "70",
        faultname: "150",
        faultlevel: "140",
        faultContent: "230",
        specificBrand: "100",
        ispopfault: "90",
        partname: "110",
        loginname: "100",
        createdon: "150",
        maintaininfo: "150",
        solutions: "120"
      },
      detailFaulcode: "故障详情",
      addUpdateDialog: {
        addfaultcode: "新增故障码",
        editfaultcode: "编辑故障码",
        faulttype: "故障类型",
        gbfault: "国标故障",
        selfdefinedfault: "自定义故障",
        faultcode: "故障码",
        faultlevel: "故障级别",
        partname: "零部件",
        ispopfault: "是否推送",
        gbfaultlevel: "国标故障级别",
        yes: "是",
        no: "否",
        level1: "一级",
        level2: "二级",
        level3: "三级",
        level4: "四级",
        faultname: "故障名称",
        maintaininfo: "维修提示",
        solutions: "解决方案",
        message1: "请输入故障码",
        message2: "请选择故障级别",
        message3: "请选择国标故障级别",
        message4: "请输入故障名称",
        message5: "新增成功",
        message6: "编辑成功",
        lengthMessage: "字符长度不能超过",
        labelWidth: {
          formLeft: "80px",
          formRight: "105px"
        }
      },
      detailWith: {
        width1: "100px",
        width2: "105px"
      }
    }
  }
} 
export default diagnostics